export default {"src":"/_next/static/media/true-or-false.af566359.svg","height":40,"width":40};